import React, { useState, useEffect } from 'react';
import { FiArrowRight, FiSend, FiMessageCircle } from 'react-icons/fi';
import {
  CONTACT_CONTENT,
  FORM_FIELDS,
  WHATSAPP_LINK,
  CONSULTATION_LINK,
} from './Contact.js';
import '../Testimonials/Testimonials.css';
import './Contact.css';

const ContactInput = ({ field, value, onChange }) => {
  return (
    <div className="cu__field">
      <input
        id={field.id}
        name={field.id}
        type={field.type}
        required={field.required}
        value={value}
        onChange={onChange}
        placeholder={field.required ? `${field.label}*` : field.label}
        className="cu__input"
      />
    </div>
  );
};


const Contact = () => {
  const [form, setForm] = useState({
    fullName: '',
    email: '',
    phone: '',
    company: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  // Auto-reset form 5 seconds after submission
  useEffect(() => {
    if (!submitted) return;
    const timer = setTimeout(() => {
      setForm({ fullName: '', email: '', phone: '', company: '', message: '' });
      setSubmitted(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, [submitted]);

  return (
    <section className="cu rt__section">
      <div className="rt__container">
        <h2 className="rv__heading" style={{ textAlign: 'center', marginBottom: '3rem' }}>
          Let's Plan <span className="text-gradient">Vietnam, Together.</span>
        </h2>
        <p className="rv__subheading" style={{ textAlign: 'center', marginTop: '-2rem', marginBottom: '3rem' }}>
          {CONTACT_CONTENT.subheading}
        </p>
      </div>
      <div className="cu__inner">
        {/* Left — Collaborate */}
        <div className="cu__collab" data-aos="fade-right">
          <h3 className="cu__collab-heading">Collaborate <span className="text-gradient">With Us</span></h3>
          <h4 className="cu__collab-sub">Elevate Your Portfolio with Florion DMC</h4>
          <p className="cu__collab-desc">
            Join our network of elite global travel designers and boutique agencies. Provide your details, and our partnership team will reach out to discuss how we can curate exceptional Southeast Asian experiences for your clientele.
          </p>
          <div className="cu__collab-items">
            <div className="cu__collab-item">
              <svg className="cu__collab-icon" viewBox="0 0 24 24">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
              </svg>
              <span>Bespoke White-Label Solutions</span>
            </div>
            <div className="cu__collab-item">
              <svg className="cu__collab-icon" viewBox="0 0 24 24">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
              </svg>
              <span>Competitive net rates for agents</span>
            </div>
            <div className="cu__collab-item">
              <svg className="cu__collab-icon" viewBox="0 0 24 24">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
              </svg>
              <span>Customized itineraries for all budgets</span>
            </div>
          </div>
        </div>

        {/* Right — Form */}
        <div className="cu__form-wrap aos-init aos-animate" data-aos="fade-left">

          <form className="cu__form" onSubmit={handleSubmit}>
            <div className="cu__form-grid">
              {FORM_FIELDS.map((field) => (
                <ContactInput
                  key={field.id}
                  field={field}
                  value={form[field.id]}
                  onChange={handleChange}
                />
              ))}
              <div className="cu__field">
                <textarea
                  id="message"
                  name="message"
                  rows="3"
                  required
                  value={form.message}
                  onChange={handleChange}
                  placeholder="Tell us about your vision for Vietnam..."
                  className="cu__textarea"
                />
              </div>
            </div>

            <div className="cu__submit-row">
              <button
                type="submit"
                className={`cu__submit ${submitted ? 'is-submitted' : ''}`}
              >
                {submitted ? (
                  <>
                    <FiSend className="cu__submit-icon" />
                    Message Sent
                  </>
                ) : (
                  <>
                    Send Inquiry
                    <FiArrowRight className="cu__submit-arrow" />
                  </>
                )}
              </button>

              <a href={CONSULTATION_LINK} className="cu__consult-btn">
                Book a Free Consultation
              </a>
            </div>
          </form>

          {submitted && (
            <div className="cu__success" data-aos="fade-up">
              <div className="cu__success-icon">
                <FiSend />
              </div>
              <p className="cu__success-text">
                Thank you — our team will be in touch within 24 hours.
              </p>
            </div>
          )}

        </div>
      </div>

      {/* WhatsApp FAB */}
      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="cu__whatsapp"
        aria-label="Chat on WhatsApp"
      >
        <FiMessageCircle className="cu__whatsapp-icon" />
      </a>
    </section>
  );
};

export default Contact;
